import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useWindowDimensions } from "../../../../utils/useWindowDimensions";
import _ from "lodash";
import moment from "moment";

import { Collapse, Spin } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";

import MainCanvas from "../../Common/Canvas/MainCanvas";
import MessageModal from "../../Common/MessageModal/index";
import HotelBaseComplianceFilterSection from "./HotelBaseComplianceFilterSection/HotelBaseComplianceFilterSection";
import QMSErrorHandle from "../../../auxil/QMSErrorHandle";
import ComplianceSummary from "../../Common/ComplianceSummary/index";
import ResultTable from "../../Common/ResultTable/Index";

import "./HotelBaseCompliance.css";

import commonConfig from "../../../commonConfig.json";
import {
  compViewskeyMapper,
  getUnique,
} from "../../../../utils/generalProcessing";
import * as actions from "../../../../store/actions/indexes";
import * as appPermissionActions from "../../../../store/actions/appPermissionActions";
import * as controlledComponentsActions from "../../../../store/actions/controlledComponentsActions";

let customTabView = commonConfig.customTabView;
let hotelStatusTypes = commonConfig.hotelStatusTypes;
let softLiveTypes = commonConfig.softLiveTypes;
let exportTypes = commonConfig.exportTypes;
let apps = commonConfig.apps;
const { Panel } = Collapse;

const HotelBaseCompliance = (props) => {
  const [compSolutions, setCompSolutions] = useState([]);
  // const [contentLoadingStatus, setContentLoadingStatus] = useState(false);
  const [allHMGCustomViewTypes, setAllHMGCustomViewTypes] = useState([]);
  const [compSearchParams, setCompSearchParams] = useState({});
  // const [searchData, setSearchData] = useState({});
  const [allSearchData, setAllSearchData] = useState({});
  const [complianceRange, setComplianceRange] = useState({});
  const [currentViewPagination, setCurrentViewPagination] = useState({});
  const [canvasType, setCanvasType] = useState("plain");
  const [exportStatus, setExportStatus] = useState({
    isSubmitExport: false,
    showExportModel: false,
    isExportEmail: false,
  });
  const [compliantPercentage, setCompliantPercentage] = useState({});
  const [signaturePercentage, setSignaturePercentage] = useState({});
  const [tableTitle, setTableTitle] = useState({});
  const [errorObject, setErrorObject] = useState({
    err: false,
    errCode: "",
    errType: "",
    errMsg: "",
    display: false,
    app: apps.COMPLIANCE,
  });

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const complianceMainTabData = useSelector(
    (state) => state.appPermissionsReducer.complianceMainTabData,
    shallowEqual
  );
  const complianceMainTabActive = useSelector(
    (state) => state.appPermissionsReducer.complianceMainTabData.active,
    shallowEqual
  );
  const compAllowCustomView = useSelector(
    (state) =>
      state.appPermissionsReducer.compliancePermissions.compAllowCustomView,
    shallowEqual
  );
  const compDefaultLoadingView = useSelector(
    (state) =>
      state.appPermissionsReducer.compliancePermissions.compDefaultLoadingView,
    shallowEqual
  );
  const isOpenSidebar = useSelector(
    (state) => state.navbarReducer.isOpen,
    shallowEqual
  );
  const compliancePermissions = useSelector(
    (state) => state.appPermissionsReducer.compliancePermissions,
    shallowEqual
  );
  const complianceTableConfigs = useSelector(
    (state) => state.complianceTableReducer,
    shallowEqual
  );
  const common = useSelector((state) => state.common, shallowEqual);
  const complianceTableData = useSelector(
    (state) => state.qmsApi.complianceTableData,
    shallowEqual
  );
  const complianceExcelExportData = useSelector(
    (state) => state.qmsApi.excelExportData,
    shallowEqual
  );
  const loggedUserData = useSelector(
    (state) => state.userDetailReducer,
    shallowEqual
  );
  const isControlledFiltersOpen = useSelector(
    (state) => state.controlledComponentsReducer.isControlledFiltersOpen,
    shallowEqual
  );
  const loaderStatus = useSelector(
    (state) => state.controlledComponentsReducer.loaderStatus,
    shallowEqual
  );

  const compSolData = useRef([]);
  // const compLoader = useRef(false);
  const compRefData = useRef({
    defaultLoad: 10,
    // tableTitle: "",
    exportModalTitle: "",
    exportType: [],
    // excelName: "",
    // worksheetName: "",
    exportStatusViewType: -1,
    exportStatusViewTitle: "",
    exportSearchData: {},
    exportEmail: [],
    exportDefaultSubject: "",
    exportCustomSubject: "",
    exportCustomBody: "",
    // prevComplianceMainTabActive : undefined
  });

  // const defaultLoad = 10;

  const printError = (newError) => {
    setErrorObject(newError);
    dispatch(controlledComponentsActions.setLoaderStatus(false));
    // setContentLoadingStatus(false);
    // compLoader.current = false
    // if (newError.errType !== 'pageErr') {
    //     setTimeout(() => {
    //         setErrorObject({
    //             err: false,
    //             errCode: "",
    //             errType: "",
    //             errMsg: "",
    //             display: false,
    //             app: apps.COMPLIANCE
    //         });
    //     }, 10000);
    // }
    return;
  };

  const customTabClick = useCallback(
    (key) => {
      if (key !== complianceMainTabActive) {
        //execept pms
        // setContentLoadingStatus(true);
        // compLoader.current = true;
        // compRefData.current.prevComplianceMainTabActive = complianceMainTabActive;
        if (
          complianceRange[complianceMainTabActive][0] !==
            complianceRange[key][0] ||
          complianceRange[complianceMainTabActive][1] !==
            complianceRange[key][1]
        ) {
          setComplianceRange({
            ...complianceRange,
            [key]: complianceRange[complianceMainTabActive],
          });
        }
        if (!_.isEmpty(compSearchParams)) {
          let tempFilter = Object.fromEntries(
            Object.entries(compSearchParams).filter(([key]) =>
              key.includes("pms")
            )
          );
          setCompSearchParams(tempFilter);
        }
        let copyOfFilterStates = JSON.parse(
          JSON.stringify(isControlledFiltersOpen)
        );
        if (!_.isEmpty(copyOfFilterStates)) {
          for (const key in copyOfFilterStates) {
            copyOfFilterStates[key] = false;
          }
          dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
        }
        dispatch(appPermissionActions.setComplianceMainActiveTab(key));
      } else {
        dispatch(controlledComponentsActions.setLoaderStatus(false));
        // setContentLoadingStatus(false);
        // compLoader.current = false
      }
    },
    [
      compSearchParams,
      dispatch,
      complianceMainTabActive,
      complianceRange,
      isControlledFiltersOpen,
    ]
  );

  const updatePagination = (changeData) => {
    //if possible add the indexName from searchData
    let paginationList = {};
    if (_.isEmpty(currentViewPagination)) {
      for (const viewType of allHMGCustomViewTypes) {
        paginationList[compViewskeyMapper(viewType, "VALUE", "KEY")] = {
          min: 0,
          max: 0,
          currentSet: 0,
          actualCount: 0,
          axisName: null,
          set: -1,
        };
      }
    } else {
      paginationList = { ...currentViewPagination };
    }

    if (changeData) {
      paginationList[complianceMainTabActive] = changeData; // TODO - check
    } else {
      let copyAllSearchData = { ...allSearchData[complianceMainTabActive] };
      if (copyAllSearchData.paginationReset) {
        // TODO - check
        if (
          !_.isEmpty(copyAllSearchData) &&
          copyAllSearchData.searchData !== undefined &&
          !_.isEmpty(copyAllSearchData.searchData)
        ) {
          let axisData = Object.entries(copyAllSearchData.searchData).find(
            ([k, v]) => k === copyAllSearchData.hotelIdx
          );
          if (
            axisData !== undefined &&
            axisData[1].searchVal !== undefined &&
            !_.isEmpty(axisData[1].searchVal)
          ) {
            if (
              axisData[1].searchVal.length < compRefData.current.defaultLoad
            ) {
              paginationList[complianceMainTabActive] = {
                min: 1,
                max: axisData[1].searchVal.length,
                currentSet: 1,
                actualCount: axisData[1].searchVal.length,
                axisName: axisData[0],
                set: 1,
              };
            } else {
              paginationList[complianceMainTabActive] = {
                min: 1,
                max: compRefData.current.defaultLoad,
                currentSet: 1,
                actualCount: axisData[1].searchVal.length,
                axisName: axisData[0],
                set: 1,
              };
            }
          } else {
            paginationList[complianceMainTabActive] = {
              min: 0,
              max: 0,
              currentSet: 0,
              actualCount: 0,
              axisName: null,
              set: 1,
            };
          }
        } else {
          paginationList[complianceMainTabActive] = {
            min: 0,
            max: 0,
            currentSet: 0,
            actualCount: 0,
            axisName: null,
            set: 1,
          };
        }
      } else {
        let copyPagination = { ...paginationList[complianceMainTabActive] };
        paginationList[complianceMainTabActive] = {
          min: copyPagination.min,
          max: copyPagination.max,
          currentSet: copyPagination.currentSet,
          actualCount: copyPagination.actualCount,
          axisName: copyPagination.axisName,
          set: 1,
        };
      }
    }

    for (const view in paginationList) {
      if (view !== complianceMainTabActive) {
        paginationList[view].set = -1;
      }
    }
    setCurrentViewPagination(paginationList);
    return;
  };

  //TODO - when setComplianceRange and refresh button click set the compSearchData.current.isNewRequest = true; and compSearchData.current.paginationReset = false;
  const updateSearchData = (data) => {
    let filterData = JSON.parse(JSON.stringify(data));
    setAllSearchData({
      ...allSearchData,
      [complianceMainTabActive]: filterData,
    }); // add for now till check for solution  for compliance range
    return;
  };

  // const updateContentLoadingStatus = useCallback((data) => {
  //     setContentLoadingStatus(data)
  //     compLoader.current = data
  // }, []);
  // const updateContentLoadingStatus = (data) => {
  //     setContentLoadingStatus(data)
  // };

  const requestProcessedSearchData = () => {
    if (
      !_.isEmpty(allSearchData) &&
      allSearchData[complianceMainTabActive] !== undefined &&
      !_.isEmpty(allSearchData[complianceMainTabActive]) &&
      allSearchData[complianceMainTabActive].searchData !== undefined
    ) {
      if (!_.isEmpty(allSearchData[complianceMainTabActive].searchData)) {
        if (!loaderStatus) {
          //directly hit refresh
          // if (!contentLoadingStatus) { //directly hit refresh
          dispatch(controlledComponentsActions.setLoaderStatus(true));
          // setContentLoadingStatus(true);
          // compLoader.current = true;
        }

        if (allSearchData[complianceMainTabActive].isNewRequest) {
          let tempSearchData = JSON.parse(
            JSON.stringify(allSearchData[complianceMainTabActive].searchData)
          );
          let hotelIdxData = Object.entries(tempSearchData).find(
            ([k, v]) => k === allSearchData[complianceMainTabActive].hotelIdx
          );
          let bDateIdxData = Object.entries(tempSearchData).find(
            ([k, v]) => k === allSearchData[complianceMainTabActive].bDateIdx
          );
          let err = false;
          if (
            hotelIdxData !== undefined &&
            hotelIdxData[1].searchVal !== undefined &&
            !_.isEmpty(hotelIdxData[1].searchVal)
          ) {
            let i = currentViewPagination[complianceMainTabActive].min;
            let filteredhotelIdxData = [];
            while (i <= currentViewPagination[complianceMainTabActive].max) {
              let index = i - 1;
              filteredhotelIdxData.push(hotelIdxData[1].searchVal[index]);
              i++;
            }

            tempSearchData[hotelIdxData[0]].searchVal = filteredhotelIdxData;

            if (
              bDateIdxData !== undefined &&
              bDateIdxData[1].searchVal !== undefined &&
              !_.isEmpty(bDateIdxData[1].searchVal)
            ) {
              let from = bDateIdxData[1].searchVal[0];
              let to = bDateIdxData[1].searchVal[1];
              let tblTitle =
                from == to ? `for ${from}` : `from ${from} to ${to}`;
              setTableTitle({
                ...tableTitle,
                [complianceMainTabActive]: tblTitle,
              });
              if (bDateIdxData[1].additionalData === "range") {
                //daily(default)
                if (
                  moment(to, "MM-DD-YYYY").diff(
                    moment(from, "MM-DD-YYYY"),
                    "days"
                  ) +
                    1 >
                  65
                ) {
                  // message.info({
                  //   content:
                  //     "This is taking a minute. Thank you for your patience. ",
                  //   duration: 0,
                  // });
                }
              } else if (bDateIdxData[1].additionalData === "adhoc") {
                //other shedules
                let adhocDates = [];
                let uniqueAdhocDates = [];
                var dt = from;

                let uniqueTriggerSchedules = _.flatten(
                  tempSearchData[hotelIdxData[0]].searchVal.map((a) => {
                    let filtered = a.customViewTypes.map(
                      (f) => f.envlopeTriggerSchedule
                    );
                    return filtered;
                  })
                ).filter((value, index, self) => self.indexOf(value) === index);

                while (
                  moment(dt, "MM-DD-YYYY").isBefore(
                    moment(to, "MM-DD-YYYY")
                  ) === true ||
                  moment(dt, "MM-DD-YYYY").isSame(moment(to, "MM-DD-YYYY")) ===
                    true
                ) {
                  for (
                    let index = 0;
                    index < uniqueTriggerSchedules.length;
                    index++
                  ) {
                    const uniqueTriggerSchedule = uniqueTriggerSchedules[index];
                    if (
                      compViewskeyMapper(
                        complianceMainTabActive,
                        "KEY",
                        "VALUE"
                      ) === customTabView.CUSTOM_MONTHLY.VALUE
                    ) {
                      if (uniqueTriggerSchedule === "lastday") {
                        let lastDay = moment(dt, "MM-DD-YYYY").endOf("month");
                        if (
                          (moment(dt, "MM-DD-YYYY").date() ===
                            lastDay.date()) ===
                          true
                        ) {
                          adhocDates.push(dt);
                        }
                      } else {
                        if (
                          moment(dt, "MM-DD-YYYY").date() ===
                          parseInt(uniqueTriggerSchedule)
                        ) {
                          adhocDates.push(dt);
                        }
                      }
                    } // add other custom trigger schedules later
                  }
                  dt = moment(dt, "MM-DD-YYYY")
                    .add(1, "day")
                    .format("MM-DD-YYYY");
                }
                uniqueAdhocDates = getUnique(adhocDates, "date", "MM-DD-YYYY");
                if (uniqueAdhocDates.length > 65) {
                  // message.info({
                  //   content:
                  //     "This is taking a minute. Thank you for your patience. ",
                  //   duration: 0,
                  // });
                }
                tempSearchData[bDateIdxData[0]].searchVal = uniqueAdhocDates;
              }
            } else {
              // TODO :Error - Please select bDateIdxData to proceed
              err = true;
              return;
            }
          } else {
            // TODO :Error - Please select hotelIdxData to proceed
            err = true;
            return;
          }

          if (!err) {
            let requestData = {
              searchData: tempSearchData,
              compUploadPermission:
                props.compliancePermissions.compliance_upload,
              compsignaturePermission:
                props.compliancePermissions.compliance_signature,
              mydocsNavPermission: compliancePermissions.compMyDocsNav,
              signatureCertPermission:
                compliancePermissions.compSignCertShowHide,
              statusView: complianceTableConfigs.status,
              transpose: complianceTableConfigs.transpose,
              userEmail: allSearchData[complianceMainTabActive].userEmail,
              managementGroup:
                allSearchData[complianceMainTabActive].managementGroup,
              solution: allSearchData[complianceMainTabActive].solution,
              pms: allSearchData[complianceMainTabActive].pms,
              bDateIdx: allSearchData[complianceMainTabActive].bDateIdx,
              hotelIdx: allSearchData[complianceMainTabActive].hotelIdx,
              reportIdx: allSearchData[complianceMainTabActive].reportIdx,
              complianceRange: complianceRange[complianceMainTabActive],
              isCustomTriggersAvailable:
                allSearchData[complianceMainTabActive]
                  .isCustomTriggersAvailable, // customViewTabsShow: ,
              selectedCustomViewTab:
                allSearchData[complianceMainTabActive].selectedCustomViewTab,
              softLiveType:
                compliancePermissions.softLiveType ||
                allSearchData[complianceMainTabActive].appConfigSoftLiveType ||
                "default",
              reportCatIdx: allSearchData[complianceMainTabActive].reportCatIdx,
              compSignatureTimestamp:
                compliancePermissions.compSignatureTimestamp,
              //   selectedCustomViewTriggerScheduleType: , // use selectedCustomViewTab
              //   selectedCustomViewTriggerIndex: ,
              //   selectedCustomViewTriggerIndexValue: ,
            };

            dispatch(actions.getComplianceTableData(requestData));
          }
        } else {
          // setContentLoadingStatus(false);
          // compLoader.current = false
          dispatch(controlledComponentsActions.setLoaderStatus(false));
        }
      } else {
        printError({
          display: true,
          err: true,
          errCode: "Error",
          errType: "",
          errMsg: "Please select the filters",
        });
      }
    }
    return;
  };

  const handleExcelExport = useCallback(
    (exportData, share) => {
      let selectedExportTypes = share
        ? exportData.reportList.map((reportType) => {
            return { type: reportType };
          })
        : [{ type: exportData }];

      for (let x = 0; x < selectedExportTypes.length; x++) {
        let exportType = selectedExportTypes[x];
        if (exportType.type === exportTypes.PERCENTAGE) {
          exportType.excelName = "Compliance_Status";
          exportType.worksheetName = "Compliance Status (%)";
        } else if (exportType.type === exportTypes.MISSING_REPORTS) {
          exportType.excelName = "Missing_Reports";
          exportType.worksheetName = "Missing Reports";
        } else if (exportType.type === exportTypes.SIGNER_DETAILS) {
          exportType.excelName = "Signer_Details";
          exportType.worksheetName = "Signer Details";
        } else if (exportType.type === exportTypes.REPORT_STATUS_TIMESTAMP) {
          exportType.excelName = "Report_Status_Timestamp";
          exportType.worksheetName = "Report Status - Timestamp";
        }
      }

      compRefData.current.exportType = selectedExportTypes;

      let statusView = complianceTableConfigs.status;
      switch (statusView) {
        case "All":
          compRefData.current.exportStatusViewTitle = "";
          compRefData.current.exportStatusViewType = 0;
          break;
        case "Signature Status":
          compRefData.current.exportStatusViewTitle = "Signature Status";
          compRefData.current.exportStatusViewType = 2;
          break;
        case "Report Status":
          compRefData.current.exportStatusViewTitle = "Report Status";
          compRefData.current.exportStatusViewType = 1;
          break;
        default:
          break;
      }

      if (
        !_.isEmpty(allSearchData) &&
        allSearchData[complianceMainTabActive] !== undefined &&
        !_.isEmpty(allSearchData[complianceMainTabActive]) &&
        allSearchData[complianceMainTabActive].searchData !== undefined
      ) {
        if (!_.isEmpty(allSearchData[complianceMainTabActive].searchData)) {
          let hotelCount = 0;
          let dateCount = 0;
          let exportSearchData = JSON.parse(
            JSON.stringify(allSearchData[complianceMainTabActive].searchData)
          );
          let hotelIdxData = Object.entries(exportSearchData).find(
            ([k, v]) => k === allSearchData[complianceMainTabActive].hotelIdx
          );
          let bDateIdxData = Object.entries(exportSearchData).find(
            ([k, v]) => k === allSearchData[complianceMainTabActive].bDateIdx
          );
          if (
            hotelIdxData !== undefined &&
            hotelIdxData[1].searchVal !== undefined &&
            !_.isEmpty(hotelIdxData[1].searchVal)
          ) {
            hotelCount = hotelIdxData[1].searchVal.length;
            if (
              bDateIdxData !== undefined &&
              bDateIdxData[1].searchVal !== undefined &&
              !_.isEmpty(bDateIdxData[1].searchVal)
            ) {
              let from = bDateIdxData[1].searchVal[0];
              let to = bDateIdxData[1].searchVal[1];
              if (bDateIdxData[1].additionalData === "range") {
                //daily(default)
                dateCount =
                  moment(to, "MM-DD-YYYY").diff(
                    moment(from, "MM-DD-YYYY"),
                    "days"
                  ) + 1;
              } else if (bDateIdxData[1].additionalData === "adhoc") {
                //other shedules
                let adhocDates = [];
                let uniqueAdhocDates = [];
                var dt = from;

                let uniqueTriggerSchedules = _.flatten(
                  exportSearchData[hotelIdxData[0]].searchVal.map((a) => {
                    let filtered = a.customViewTypes.map(
                      (f) => f.envlopeTriggerSchedule
                    );
                    return filtered;
                  })
                ).filter((value, index, self) => self.indexOf(value) === index);

                while (
                  moment(dt, "MM-DD-YYYY").isBefore(
                    moment(to, "MM-DD-YYYY")
                  ) === true ||
                  moment(dt, "MM-DD-YYYY").isSame(moment(to, "MM-DD-YYYY")) ===
                    true
                ) {
                  for (
                    let index = 0;
                    index < uniqueTriggerSchedules.length;
                    index++
                  ) {
                    const uniqueTriggerSchedule = uniqueTriggerSchedules[index];
                    if (
                      compViewskeyMapper(
                        complianceMainTabActive,
                        "KEY",
                        "VALUE"
                      ) === customTabView.CUSTOM_MONTHLY.VALUE
                    ) {
                      if (uniqueTriggerSchedule === "lastday") {
                        let lastDay = moment(dt, "MM-DD-YYYY").endOf("month");
                        if (
                          (moment(dt, "MM-DD-YYYY").date() ===
                            lastDay.date()) ===
                          true
                        ) {
                          adhocDates.push(dt);
                        }
                      } else {
                        if (
                          moment(dt, "MM-DD-YYYY").date() ===
                          parseInt(uniqueTriggerSchedule)
                        ) {
                          adhocDates.push(dt);
                        }
                      }
                    } // add other custom trigger schedules later
                  }
                  dt = moment(dt, "MM-DD-YYYY")
                    .add(1, "day")
                    .format("MM-DD-YYYY");
                }
                uniqueAdhocDates = getUnique(adhocDates, "date", "MM-DD-YYYY");
                exportSearchData[bDateIdxData[0]].searchVal = uniqueAdhocDates;
                dateCount = uniqueAdhocDates.length;
              }
              compRefData.current.exportModalTitle = `Excel Export - ${
                hotelCount > 1
                  ? "Multiple Hotels"
                  : hotelIdxData[1].searchVal[0].codeEnv
              } - ${from === to ? from : from + " - " + to}`;
              compRefData.current.exportSearchData = exportSearchData;
              let tempExportStatus = { ...exportStatus };
              if (share) {
                tempExportStatus["showExportModel"] = false;
                tempExportStatus["isExportEmail"] = true;
                tempExportStatus["isSubmitExport"] = true;
                compRefData.current.exportEmail = exportData.recipients.map(
                  (mail) => mail.value
                );
                compRefData.current.exportCustomSubject =
                  exportData.emailSubject || "";
                compRefData.current.exportCustomBody =
                  exportData.emailBody || "";
                compRefData.current.share = true;
                setExportStatus(tempExportStatus);
              } else if (
                hotelCount > process.env["REACT_APP_EXPORT_HOTEL_SLICE"] ||
                dateCount * hotelCount > process.env["REACT_APP_MAIL_EXCEL"]
              ) {
                // export on email

                tempExportStatus["showExportModel"] = true;
                tempExportStatus["isExportEmail"] = true;
                setExportStatus(tempExportStatus);
              } else {
                dispatch(controlledComponentsActions.setLoaderStatus(true));
                // setContentLoadingStatus(true);
                // compLoader.current = true;
                tempExportStatus["isSubmitExport"] = true;
                setExportStatus(tempExportStatus);
              }
            } else {
              printError({
                display: true,
                err: true,
                errCode: "Error",
                errType: "",
                errMsg: `${
                  allSearchData[complianceMainTabActive].bDateIdx
                } range selected is not applicable to ${compViewskeyMapper(
                  complianceMainTabActive,
                  "KEY",
                  "TEXT"
                )}`,
              });
            }
          } else {
            printError({
              display: true,
              err: true,
              errCode: "Error",
              errType: "",
              errMsg: `${compViewskeyMapper(
                complianceMainTabActive,
                "KEY",
                "TEXT"
              )} not enabled for selected ${
                allSearchData[complianceMainTabActive].hotelIdx
              }`,
            });
          }
        }
      }
    },
    [
      allSearchData,
      complianceMainTabActive,
      complianceTableConfigs,
      exportStatus,
    ]
  );

  const requestExport = (value, exportVal, email) => {
    let tempExportStatus = { ...exportStatus };
    if (exportVal) {
      if (email !== "" && email !== undefined) {
        compRefData.current.exportEmail = [email];
        tempExportStatus["isSubmitExport"] = true;
      } else {
        printError({
          display: true,
          err: true,
          errCode: "Error",
          errType: "",
          errMsg: "Please enter an email address",
        });
      }
    }
    tempExportStatus["showExportModel"] = value;
    setExportStatus(tempExportStatus);
    return;
  };

  const handleComplianceRange = useCallback(
    (newRange) => {
      newRange[0] = newRange[0] / 100;
      newRange[1] = newRange[1] / 100;
      if (
        complianceRange[complianceMainTabActive][0] !== newRange[0] ||
        complianceRange[complianceMainTabActive][1] !== newRange[1]
      ) {
        setComplianceRange({
          ...complianceRange,
          [complianceMainTabActive]: newRange,
        });
      }
    },
    [complianceRange, complianceMainTabActive]
  );

  const handleRefresh = useCallback(() => {
    if (
      !_.isEmpty(allSearchData) &&
      allSearchData[complianceMainTabActive] !== undefined &&
      !_.isEmpty(allSearchData[complianceMainTabActive])
    ) {
      let copyOfAllSearchData = { ...allSearchData[complianceMainTabActive] };
      copyOfAllSearchData.isNewRequest = true;
      copyOfAllSearchData.paginationReset = false;
      setAllSearchData({
        ...allSearchData,
        [complianceMainTabActive]: copyOfAllSearchData,
      });
    }
  }, [allSearchData]);

  useEffect(() => {
    let allowedSol = ["PNA"]; // remove after multiple solution allowed
    dispatch(controlledComponentsActions.setLoaderStatus(true));
    // setContentLoadingStatus(true);
    // compLoader.current = true;
    if (props.solutions !== undefined && props.solutions.length !== 0) {
      let filteredSolutions = _.reduce(
        props.solutions,
        (accum, s, i) => {
          let filteredproj = _.filter(
            s.projectList,
            (p) => allowedSol.includes(p.solution) === true
          );
          if (filteredproj.length > 0) {
            accum.push({
              entityId: s.entityId,
              hmg_custom_views: s.hmg_custom_views,
              hmg_name: s.hmg_name,
              projectList: filteredproj,
            });
          }
          return accum;
        },
        []
      ); // remove after multiple solution allowed
      compSolData.current = filteredSolutions; // remove after multiple solution allowed
      if (filteredSolutions.length !== 0) {
        let tempallHMGCustomViewTypes = _.flatten(
          props.solutions.map((h) => h.hmg_custom_views)
        ).filter((value, index, self) => self.indexOf(value) === index);

        let sessionParams = sessionStorage.getItem("compParams");
        if (sessionParams !== undefined) {
          setCompSearchParams(JSON.parse(sessionParams));
        }
        if (tempallHMGCustomViewTypes.length !== 0) {
          setAllHMGCustomViewTypes(tempallHMGCustomViewTypes);
        }
      } else {
        // remove after multiple solution allowed
        printError({
          display: true,
          err: true,
          errCode: "Error",
          errType: "",
          errMsg: "No Management Group available with PNA Solution",
        });
        dispatch(controlledComponentsActions.setLoaderStatus(false));
        // setContentLoadingStatus(false);
        // compLoader.current = false
      }
    } else {
      printError({
        display: true,
        err: true,
        errCode: "Error",
        errType: "",
        errMsg: "No Management Group assigned for the user",
      });
      dispatch(controlledComponentsActions.setLoaderStatus(false));
      // setContentLoadingStatus(false);
      // compLoader.current = false
    }
  }, [props.solutions]);

  useEffect(() => {
    if (allHMGCustomViewTypes.length !== 0) {
      let tabData = {
        list: [],
        active: "",
        disabled: [],
        tabPosition: "right",
      };
      let tabList = [];
      let disabledTabs = [];
      let percentageTabList = {};
      let complianceRangeTabList = {};

      if (
        compDefaultLoadingView !== undefined ||
        compDefaultLoadingView !== "Daily"
      ) {
        if (
          compAllowCustomView === undefined ||
          compAllowCustomView === false
        ) {
          tabData.active = customTabView.DEFAULT.KEY;
        } else {
          tabData.active = compViewskeyMapper(
            compDefaultLoadingView,
            "VALUE",
            "KEY"
          );
        }
      } else {
        tabData.active = customTabView.DEFAULT.KEY;
      }

      if (
        !_.isEmpty(compSearchParams) &&
        compSearchParams.triggerSchedule !== undefined
      ) {
        if (compSearchParams.triggerSchedule !== "") {
          if (compSearchParams.triggerSchedule !== "Daily") {
            if (
              compAllowCustomView === undefined ||
              compAllowCustomView === false
            ) {
              tabData.active = customTabView.DEFAULT.KEY;
              printError({
                display: true,
                err: true,
                errCode: "Warning",
                errType: "",
                errMsg: `Redirection has no access to the ${compSearchParams.triggerSchedule} View by user access`,
              });
              dispatch(controlledComponentsActions.setLoaderStatus(false));
              // setContentLoadingStatus(false);
              // compLoader.current = false
            } else {
              tabData.active = compViewskeyMapper(
                compSearchParams.triggerSchedule,
                "VALUE",
                "KEY"
              );
            }
          } else {
            tabData.active = customTabView.DEFAULT.KEY;
          }
        }
      }

      for (const type of allHMGCustomViewTypes) {
        tabList.push({
          key: compViewskeyMapper(type, "VALUE", "KEY"),
          value: compViewskeyMapper(type, "VALUE", "TEXT"),
          // disabled: type !== "Daily" ? (this.props.compAllowCustomView === undefined || this.props.compAllowCustomView === false ? true : false): (false)
        });
        if (type !== "Daily") {
          if (
            compAllowCustomView === undefined ||
            compAllowCustomView === false
          ) {
            disabledTabs.push(compViewskeyMapper(type, "VALUE", "KEY"));
          }
        }
        percentageTabList = _.merge(percentageTabList, {
          [compViewskeyMapper(type, "VALUE", "KEY")]: 0,
        });
        complianceRangeTabList = _.merge(complianceRangeTabList, {
          [compViewskeyMapper(type, "VALUE", "KEY")]: [0.0, 1.0],
        });
      }

      tabData.list = tabList;
      tabData.disabled = disabledTabs;
      // compRefData.current.prevComplianceMainTabActive = tabData.active;
      dispatch(appPermissionActions.setComplianceMainTabData(tabData));
      setCompliantPercentage(percentageTabList);
      setSignaturePercentage(percentageTabList);
      setComplianceRange(complianceRangeTabList);
      if (allHMGCustomViewTypes.length > 1) {
        setCanvasType("tabs");
      }
      setCompSolutions(compSolData.current); // remove after multiple solution allowed
      // setCompSolutions(props.solutions); //enable after multiple solution allowed
    }
    // else {
    //     printError({
    //         display: true,
    //         err: true,
    //         errCode: "Error",
    //         errType: "",
    //         errMsg: "No View types available for the Management Group(s) assigned for the user",
    //     });
    //     setContentLoadingStatus(false);
    // }
  }, [allHMGCustomViewTypes]);

  useEffect(() => {
    if (
      !_.isEmpty(allSearchData) &&
      allSearchData[complianceMainTabActive] !== undefined
    ) {
      if (!_.isEmpty(allSearchData[complianceMainTabActive])) {
        compRefData.current.exportDefaultSubject = mailSubjectFormatter(
          allSearchData[complianceMainTabActive]
        );
        updatePagination();
      }
    }

    //   return () => {
    //     second
    //   }
  }, [allSearchData]);

  const mailSubjectFormatter = (copyOfAllSearchData) => {
    let hotels =
      copyOfAllSearchData.searchData[copyOfAllSearchData.hotelIdx].searchVal;
    let dates =
      copyOfAllSearchData.searchData[copyOfAllSearchData.bDateIdx].searchVal;

    if (hotels.length > 0 && dates.length > 0) {
      return (
        "Compliance Dashboard Status - Excel Export - " +
        (hotels.length > 1
          ? "Multiple Hotels"
          : hotels[0].code != "" && hotels[0].name != ""
          ? hotels[0].code + " - " + hotels[0].name
          : hotels[0].hotelEnv === "Marriott"
          ? hotels[0].code
          : hotels[0].name) +
        " - " +
        (moment(dates[0], "MM-DD-YYYY").isSame(
          moment(dates[dates.length - 1], "MM-DD-YYYY")
        )
          ? dates[0]
          : dates[0] + " - " + dates[dates.length - 1])
      );
    } else {
      return "";
    }
  };

  useEffect(() => {
    if (
      !_.isEmpty(currentViewPagination) &&
      currentViewPagination[complianceMainTabActive] !== undefined
    ) {
      requestProcessedSearchData();
    }
    //   return () => {
    //     second
    //   }
  }, [currentViewPagination]);

  useEffect(() => {
    if (
      !_.isEmpty(complianceRange) &&
      complianceRange[complianceMainTabActive] !== undefined
    ) {
      if (
        !_.isEmpty(allSearchData) &&
        allSearchData[complianceMainTabActive] !== undefined &&
        !_.isEmpty(allSearchData[complianceMainTabActive])
      ) {
        let copyOfAllSearchData = { ...allSearchData[complianceMainTabActive] };
        copyOfAllSearchData.isNewRequest = true;
        copyOfAllSearchData.paginationReset = false; // TODO :problem identify actual new request and compliance range change
        setAllSearchData({
          ...allSearchData,
          [complianceMainTabActive]: copyOfAllSearchData,
        });
      }
    }
    //   return () => {
    //     second
    //   }
  }, [complianceRange]);

  useEffect(() => {
    if (
      !_.isEmpty(allSearchData) &&
      allSearchData[complianceMainTabActive] !== undefined &&
      !_.isEmpty(allSearchData[complianceMainTabActive])
    ) {
      if (common.loading !== true && common.error === null) {
        if (
          !_.isEmpty(complianceTableData) &&
          complianceTableData[complianceMainTabActive] !== undefined
        ) {
          let latestTableData = complianceTableData[complianceMainTabActive];
          let tempcompliantPercentage = 0.0;
          let tempsignaturePercentage = 0.0;
          let totalReports = 0;
          let submitted = 0;
          let totalSign = 0;
          let signed = 0;

          // setContentLoadingStatus(false); // for now.. remove after connecting to table loading
          // compLoader.current = false
          latestTableData.forEach((hotel) => {
            hotel.forEach((date) => {
              let keys = Object.keys(date);
              keys.forEach((key) => {
                date[key].reports.forEach((cell) => {
                  if (
                    (cell.cellStatus === hotelStatusTypes.SLIVE &&
                      softLiveTypes.WITH_SUMMARY ===
                        (compliancePermissions.softLiveType ||
                          allSearchData[complianceMainTabActive]
                            .appConfigSoftLiveType ||
                          "default")) ||
                    (cell.cellStatus === hotelStatusTypes.LIVE &&
                      cell.isHotelLive) ||
                    cell.cellStatus === hotelStatusTypes.UAT
                  ) {
                    totalReports += cell.totalReports;
                    submitted += cell.availableCount;

                    if (
                      ![
                        "Not Applicable",
                        "Incorrect Configuration",
                        "Hotel Signature Process Not Live",
                        "Not compliant with range",
                        "Not in config range",
                      ].includes(cell.signatureCell.text)
                    ) {
                      totalSign += 1;
                      if (cell.signatureCell.gradient === undefined) {
                        let ratio = cell.signatureCell.signedRatio.split("/");
                        let sigratio = parseInt(ratio[0]) / parseInt(ratio[1]);
                        signed += isNaN(sigratio) ? 0 : sigratio;
                      }
                    }
                  }
                });
              });
            });
          });

          tempcompliantPercentage =
            submitted !== 0 && totalReports !== 0
              ? (submitted / totalReports) * 100
              : 0.0;
          tempsignaturePercentage =
            signed !== 0 && totalSign !== 0 ? (signed / totalSign) * 100 : 0.0;

          setCompliantPercentage({
            ...compliantPercentage,
            [complianceMainTabActive]: tempcompliantPercentage,
          });
          setSignaturePercentage({
            ...signaturePercentage,
            [complianceMainTabActive]: tempsignaturePercentage,
          });
          dispatch(controlledComponentsActions.setLoaderStatus(false));
        }
      } else if (common.loading !== true && common.error !== null) {
        //TODO: Error -
      }
    }

    //   return () => {
    //     second
    //   }
  }, [complianceTableData]);

  useEffect(() => {
    if (
      exportStatus.isSubmitExport &&
      !_.isEmpty(compRefData.current.exportSearchData)
    ) {
      let requestData = {
        searchData: compRefData.current.exportSearchData,
        compUploadPermission: props.compliancePermissions.compliance_upload,
        compsignaturePermission:
          props.compliancePermissions.compliance_signature,
        mydocsNavPermission: compliancePermissions.compMyDocsNav,
        signatureCertPermission: compliancePermissions.compSignCertShowHide,
        statusView: compRefData.current.exportStatusViewType,
        transpose: complianceTableConfigs.transpose,
        userEmail: allSearchData[complianceMainTabActive].userEmail,
        managementGroup: allSearchData[complianceMainTabActive].managementGroup,
        solution: allSearchData[complianceMainTabActive].solution,
        pms: allSearchData[complianceMainTabActive].pms,
        bDateIdx: allSearchData[complianceMainTabActive].bDateIdx,
        hotelIdx: allSearchData[complianceMainTabActive].hotelIdx,
        reportIdx: allSearchData[complianceMainTabActive].reportIdx,
        complianceRange: complianceRange[complianceMainTabActive],
        isCustomTriggersAvailable:
          allSearchData[complianceMainTabActive].isCustomTriggersAvailable, // customViewTabsShow: ,
        selectedCustomViewTab:
          allSearchData[complianceMainTabActive].selectedCustomViewTab,
        softLiveType:
          compliancePermissions.softLiveType ||
          allSearchData[complianceMainTabActive].appConfigSoftLiveType ||
          "default",
        reportCatIdx: allSearchData[complianceMainTabActive].reportCatIdx,
        excelExp: true,
        sendEmail: exportStatus.isExportEmail,
        exportType: compRefData.current.exportType,
        userName: loggedUserData.rawUserName,
        compSignatureTimestamp: compliancePermissions.compSignatureTimestamp,
      };
      if (exportStatus.isExportEmail) {
        requestData.dwnldStatus = compRefData.current.exportStatusViewTitle;
        requestData.emailAddress = compRefData.current.exportEmail;
        requestData.exportCustomSubject =
          compRefData.current.exportDefaultSubject +
          " " +
          compRefData.current.exportCustomSubject;
        requestData.exportCustomBody = compRefData.current.exportCustomBody;
        requestData.senderName = loggedUserData.userName;
        requestData.senderEmail = loggedUserData.userEmail;
        requestData.share = compRefData.current.share;
      }
      dispatch(actions.getExcelExportData(requestData));
    }
  }, [exportStatus.isSubmitExport]);

  useEffect(() => {
    if (exportStatus.isSubmitExport && !_.isEmpty(complianceExcelExportData)) {
      if (common.loading !== true && common.error === null) {
        if (!exportStatus.isExportEmail) {
          let dwnldHotel =
            compRefData.current.exportSearchData[
              allSearchData[complianceMainTabActive]["hotelIdx"]
            ];
          let dwnldDate =
            allSearchData[complianceMainTabActive].searchData[
              allSearchData[complianceMainTabActive]["bDateIdx"]
            ];
          // let dwnldDate = compRefData.current.exportSearchData[allSearchData[complianceMainTabActive]['bDateIdx']];

          let fileName = `${
            compRefData.current.exportType[0].excelName
          }_${compViewskeyMapper(
            complianceMainTabActive,
            "KEY",
            "VALUE"
          )}_View_${
            dwnldHotel.searchVal.length > 1
              ? "Multiple_Hotels"
              : dwnldHotel.searchVal[0].code !== "" &&
                dwnldHotel.searchVal[0].name !== ""
              ? dwnldHotel.searchVal[0].code +
                " - " +
                dwnldHotel.searchVal[0].name
              : dwnldHotel.searchVal[0].codeEnv
          }_${
            moment(dwnldDate.searchVal[0], "MM-DD-YYYY").isSame(
              moment(dwnldDate.searchVal[1], "MM-DD-YYYY")
            )
              ? dwnldDate.searchVal[0]
              : dwnldDate.searchVal[0] + " - " + dwnldDate.searchVal[1]
          }`;

          const url = window.URL.createObjectURL(
            new Blob([complianceExcelExportData.data])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName + ".xlsx");
          document.body.appendChild(link);
          link.click();
          dispatch(controlledComponentsActions.setLoaderStatus(false));
          // setContentLoadingStatus(false);
          // compLoader.current = false
        }
      } else if (common.loading !== true && common.error !== null) {
        //TODO: Error -
      }
      let tempExportStatus = { ...exportStatus };
      tempExportStatus["isExportEmail"] = false;
      tempExportStatus["isSubmitExport"] = false;
      setExportStatus(tempExportStatus);
      compRefData.current.exportModalTitle = "";
      compRefData.current.exportType = [];
      compRefData.current.exportStatusViewType = -1;
      compRefData.current.exportStatusViewTitle = "";
      compRefData.current.exportSearchData = {};
      compRefData.current.exportEmail = [];
      compRefData.current.currentexportDefaultSubject = mailSubjectFormatter(
        allSearchData[complianceMainTabActive]
      );
      compRefData.current.exportCustomBody = "";
      compRefData.current.exportCustomSubject = "";
      compRefData.current.share = false;
    }
  }, [complianceExcelExportData]);

  useLayoutEffect(() => {
    if (errorObject.errType !== "" && errorObject.errType !== "pageErr") {
      setErrorObject({
        err: false,
        errCode: "",
        errType: "",
        errMsg: "",
        display: false,
        app: apps.COMPLIANCE,
      });
      dispatch(controlledComponentsActions.setLoaderStatus(false));
      // setContentLoadingStatus(false);
      // compLoader.current = false
    }
  }, [errorObject]);

  return errorObject.err === true && errorObject.errType === "pageErr" ? (
    <QMSErrorHandle errordetails={errorObject} />
  ) : (
    <div
      className={
        width < 768 ? "" : isOpenSidebar ? "sidebarExpand" : "sidebarCollapse"
      }
      style={{ padding: "0px 15px" }}
    >
      {errorObject.display === true && errorObject.errType !== "pageErr" ? (
        <QMSErrorHandle errordetails={errorObject} />
      ) : (
        ""
      )}
      <MessageModal
        modalTitle={compRefData.current.exportModalTitle}
        visible={exportStatus.showExportModel}
        email={loggedUserData.userEmail}
        onHandleCancel={requestExport}
      />
      <Spin tip="Loading..." spinning={loaderStatus}>
        {/* <Spin tip="Loading..." spinning={compLoader.current}> */}
        {/* <Spin tip="Loading..." spinning={contentLoadingStatus}> */}
        {(canvasType !== "plain" && complianceMainTabData !== {}) ||
        canvasType === "plain" ? (
          <MainCanvas
            appName={width < 768 ? "Dashboard" : "Compliance Dashboard"}
            canvasType={canvasType}
            canvasData={complianceMainTabData}
            canvasCallback={(key) => {
              dispatch(controlledComponentsActions.setLoaderStatus(true));
              // setContentLoadingStatus(true);
              // compLoader.current = true;
              customTabClick(key);
            }}
          >
            {compSolutions.length !== 0 ? (
              <>
                <HotelBaseComplianceFilterSection
                  className="hotelBaseComplianceFilterSection"
                  projectDetails={compSolutions}
                  allHMGCustomViewTypes={allHMGCustomViewTypes}
                  // user={props.user}
                  compSearchParams={compSearchParams}
                  compSearchParamsCallback={setCompSearchParams} // this can use useCallback
                  updateSearchData={updateSearchData}
                  // contentLoadingStatus={updateContentLoadingStatus}
                />
                {!_.isEmpty(compliantPercentage) &&
                !_.isEmpty(signaturePercentage) ? (
                  compliantPercentage[complianceMainTabActive] !== undefined &&
                  signaturePercentage[complianceMainTabActive] !== undefined ? (
                    <Collapse
                      className="complianceSummaryCollapse"
                      defaultActiveKey={["compliance_summary_panel"]}
                      expandIconPosition={"right"}
                      expandIcon={({ isActive }) => (
                        <DoubleRightOutlined rotate={isActive ? -90 : 90} />
                      )}
                    >
                      <Panel
                        className="complianceSummaryPanel"
                        header="Compliance Summary"
                        key="compliance_summary_panel"
                      >
                        <ComplianceSummary
                          compliantPercentage={
                            compliantPercentage[complianceMainTabActive]
                          }
                          signaturePercentage={
                            signaturePercentage[complianceMainTabActive]
                          }
                        />
                      </Panel>
                    </Collapse>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
                {!_.isEmpty(currentViewPagination) &&
                currentViewPagination[complianceMainTabActive] !== undefined ? (
                  <Collapse
                    className="complianceTableCollapse"
                    defaultActiveKey={["compliance_table_panel"]}
                    expandIconPosition={"right"}
                    expandIcon={({ isActive }) => (
                      <DoubleRightOutlined rotate={isActive ? -90 : 90} />
                    )}
                  >
                    <Panel
                      className="complianceTablePanel"
                      header={`
                                                        ${
                                                          complianceTableConfigs.status ===
                                                          "All"
                                                            ? "Report and Signature Status "
                                                            : complianceTableConfigs.status
                                                        } 
                                                        ${
                                                          width < 768
                                                            ? ""
                                                            : tableTitle[
                                                                complianceMainTabActive
                                                              ] !== undefined
                                                            ? tableTitle[
                                                                complianceMainTabActive
                                                              ]
                                                            : ""
                                                        }
                                                    `}
                      key="compliance_table_panel"
                    >
                      <ResultTable
                        settings={{
                          defaultCount: compRefData.current.defaultLoad,
                          indexes:
                            currentViewPagination[complianceMainTabActive],
                        }}
                        changeHotelView={updatePagination}
                        // tableData={this.state.compData}
                        refreshTbl={handleRefresh}
                        handleExcelExport={handleExcelExport}
                        compliance_signature={
                          props.compliancePermissions.compliance_signature
                        }
                        compliance_upload={
                          props.compliancePermissions.compliance_upload
                        }
                        complianceRange={
                          complianceRange[complianceMainTabActive]
                        }
                        setCompRange={handleComplianceRange}
                        exportSearchData={complianceExcelExportData}
                        exportDefaultSubject={
                          compRefData.current.exportDefaultSubject
                        }
                      />
                    </Panel>
                  </Collapse>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </MainCanvas>
        ) : (
          ""
        )}
      </Spin>
    </div>
  );
};

export default React.memo(HotelBaseCompliance);
